
import { ThemeProvider } from "styled-components";
import Routes from "./routes";
import  { Toaster } from 'react-hot-toast';
import { StateProvider } from "./store/StateProvider";
const theme = {
  xl: "@media screen and (min-width: 1536px)",
  lg: "@media screen and (min-width: 1200px)",
  md: "@media screen and (min-width: 900px)",
  sm: "@media screen and (min-width: 600px)",
  xs: "@media screen and (min-width: 0px)",
};


function App() {
  return (
    <ThemeProvider theme={theme}>
      <StateProvider>
         <Toaster />
        <Routes />
      </StateProvider>
    </ThemeProvider>
  );
}

export default App;
